'use client';

import { Button } from '@repo/ui/button';
import * as Sentry from '@sentry/nextjs';
import { useTranslations } from 'next-intl';
import { startTransition, useEffect } from 'react';
import { UnStyledLink } from '@/components/common/link';
import { useRouter } from '@/i18n/routing';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const t = useTranslations('error-boundary');

  const router = useRouter();

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  function refreshAndReset() {
    // Refresh both the client and the server in a synchronous way
    startTransition(() => {
      router.refresh();
      reset();
    });
  }

  return (
    <div className="relative mx-auto grid h-dvh place-items-center">
      <div className="relative z-10 flex flex-col items-center justify-center text-center">
        <p className="text-[2rem] leading-tight text-white vt-font-weight-bold sm:text-[2.75rem]">{t('title')}</p>
        <p className="my-3 text-[1rem] text-white sm:text-[1.25rem]">
          {t.rich('subtitle', {
            link: (chunks) => (
              <a
                href={`mailto:${chunks}`}
                target="_blank"
                rel="noreferrer"
                className="underline"
              >
                {chunks}
              </a>
            ),
          })}
        </p>
        <div className="mb-10 mt-10 flex flex-col items-center space-y-2">
          <Button onClick={refreshAndReset}>{t('try-again')}</Button>
          <span>{t('or')}</span>
          <Button
            variant="inverted"
            asChild
          >
            <UnStyledLink href="/">{t('go-back-to-home')}</UnStyledLink>
          </Button>
        </div>
      </div>
    </div>
  );
}
